<style lang="scss" src="./TopMenu.scss"></style>
<script lang="ts" src="./TopMenu.ts"></script>

<template>
  <div class="top-navigation">
    <template v-for="item in menu" :key="item.id">
      <div v-if="
        !item.disabled &&
        Array.isArray(item.ownerRole) &&
        item.ownerRole.includes(store.state.ownerRole) &&
        Array.isArray(store.state.userVaultnPermissions) &&
        Array.isArray(item.rbacRole) &&
        item.rbacRole.some(r => store.state.userVaultnPermissions.includes(r)) &&
        (!item.featureFlag || featureFlagChecks[item.featureFlag]?.value)
      " class="float-left margin-right-20">
        <q-btn color="primary" :label="item.text" :to="item.href" :class="{ highlighted: item.id === highlightedIndex }"
          :style="item.id === highlightedIndex ? 'color: #2aa1e8; font-weight: 600;' : ''" />
      </div>

    </template>
  </div>
</template>
